<template>
  <div class="complete__table--row" @mousemove="focused = true" @mouseenter="focused = true"
       @mouseleave="focused = false">
    <div class="complete--property button--right">
      <button type="button" class="btn-plain" v-if="focused || isMobile()" @click.prevent="deleteDevice()">❌
      </button>
    </div>
    <div class="complete--property">
      <label>Aantal</label>
      <input
        type="number"
        class="input--transparent"
        v-bind:class="{'error': this.$v.newQty.$dirty && this.$v.newQty.$invalid}"
        v-model="$v.newQty.$model"
        style="width: 60px;"
        min="0"
        max="9999"
      />
    </div>
    <div class="complete--property">
      <label>Naam apparaat</label>
      <input
        type="text"
        class="input--transparent"
        v-on:blur="this.$v.newDeviceName.$touch"
        v-bind:class="{'error': this.$v.newDeviceName.$dirty && this.$v.newDeviceName.$invalid, 'verify': this.verify, 'dirty': this.$v.newDeviceName.$dirty}"
        v-model.trim="$v.newDeviceName.$model"
        placeholder="Bijv. computer"
      />
    </div>
    <div class="complete--property justify-content-lg-center">
      <label>Vermogen apparaat</label>
      <div>
        <input
          type="number"
          class="input--transparent"
          v-bind:class="{'error': this.$v.newWattage.$dirty && this.$v.newWattage.$invalid}"
          v-model.trim="$v.newWattage.$model"
          min="0"
          max="15000"
        /> Watt
      </div>
    </div>
    <div class="complete--property justify-content-lg-center">
      <label>Tegelijkertijd</label>
      <input
        type="checkbox"
        class="form-check"
        v-model="newSimultaneous"
      />
    </div>
    <div class="complete--property justify-content-lg-center">
      <label>Gebruiksduur p.d.</label>
      <div>
        Aantal
        <input
          type="number"
          class="input--transparent"
          v-bind:class="{'error': this.$v.newMinutes.$dirty && this.$v.newMinutes.$invalid}"
          v-model.trim="$v.newMinutes.$model"
          min="0"
          max="1440"
        /> minuten per dag
      </div>
    </div>
  </div>
</template>

<script>
import Vuelidate from 'vuelidate'
import Vue from 'vue'
import {integer, maxValue, minLength, minValue, required} from "vuelidate/lib/validators";

Vue.use(Vuelidate);

export default {
  validations: {
    newQty: {
      required,
      integer,
      minValue: minValue(1)
    },
    newDeviceName: {
      required,
      minLength: minLength(1)
    },
    newWattage: {
      required,
      integer,
      minValue: minValue(1)
    },
    newMinutes: {
      required,
      integer,
      minValue: minValue(1),
      maxValue: maxValue(1440)
    },
  },
  data() {
    return {
      newQty: 1,
      newDeviceName: '',
      newWattage: 0,
      newSimultaneous: false,
      newMinutes: 0,
      focused: false,
    };
  },
  props: {
    verify: Boolean,
    qty: Number,
    deviceName: String,
    wattage: Number,
    simultaneous: Boolean,
    minutes: Number
  },
  watch: {
    verify: function (newValue, oldValue) {
      console.log(this.$v.newDeviceName.$touch());

      // this.$v.newQty.$touch;
      // this.$v.newWattage.$touch;
      // this.$v.newSimultaneous.$touch;
      // this.$v.newMinutes.$touch;
      // this.$v.focused.$touch;
    },
    newQty: function (newValue, oldValue) {
      this.$emit('update:qty', parseInt(newValue))
    },
    newDeviceName: function (newValue, oldValue) {
      this.$emit('update:deviceName', newValue)
    },
    newWattage: function (newValue, oldValue) {
      this.$emit('update:wattage', parseInt(newValue))
    },
    newSimultaneous: function (newValue, oldValue) {
      this.$emit('update:simultaneous', newValue)
    },
    newMinutes: function (newValue, oldValue) {
      this.$emit('update:minutes', parseInt(newValue))
    }
  },
  methods: {
    isMobile: function () {
      return !window.matchMedia('(min-width: 992px)').matches
    },
    finishEditing: function (property) {
      let value;
      if (property === 'qty') {
        this.$emit('update:qty', this.newQty)
      } else if (property === 'deviceName') {
        this.$emit('update:title', this.newDeviceName)
      } else if (property === 'wattage') {
        this.$emit('update:wattage', this.newWattage)
      } else if (property === 'simultaneous') {
        this.$emit('update:simultaneous', this.newSimultaneous)
      } else if (property === 'minutes') {
        this.$emit('update:minutes', this.newMinutes)
      }
    },
    deleteDevice() {
      this.$emit('on-delete')
    }
  },
  created() {
    if (this.verify) {
      console.log(this.$v.newDeviceName.$touch());
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
